import { render, staticRenderFns } from "./NewSolutions.vue?vue&type=template&id=24344de0&scoped=true&"
import script from "./NewSolutions.vue?vue&type=script&lang=js&"
export * from "./NewSolutions.vue?vue&type=script&lang=js&"
import style0 from "./NewSolutions.vue?vue&type=style&index=0&id=24344de0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24344de0",
  null
  
)

export default component.exports